export default "__VITE_ASSET__DpXEduDc__"